"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Fraserland Organics
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 2.1.10-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotesToJSON = exports.NotesFromJSONTyped = exports.NotesFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function NotesFromJSON(json) {
    return NotesFromJSONTyped(json, false);
}
exports.NotesFromJSON = NotesFromJSON;
function NotesFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ..._1.AbstractFormFromJSONTyped(json, ignoreDiscriminator),
        '_id': !runtime_1.exists(json, '_id') ? undefined : json['_id'],
        'notes': json['notes'],
    };
}
exports.NotesFromJSONTyped = NotesFromJSONTyped;
function NotesToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ..._1.AbstractFormToJSON(value),
        '_id': value._id,
        'notes': value.notes,
    };
}
exports.NotesToJSON = NotesToJSON;
